import axios from 'axios'

const API_URL = process.env.API_URL

const FETCH_SERVERS = 'FETCH_SERVERS'
const FETCH_SERVERS_SUCCESS = 'FETCH_SERVERS_SUCCESS'
const FETCH_SERVERS_FAILURE = 'FETCH_SERVERS_FAILURE'
const SELECT_SERVER_ID = 'SELECT_SERVER_ID'
const CACHE_REPORT_IMAGES = 'CACHE_REPORT_IMAGES'

const initialState = {
  entities: {},
  ids: [],
  selectedEntityId: null,
  isFetching: false,
  cache: {}
}

const getters = {
  getCachedImages: state => report => {
    const serverCache = state.cache[state.selectedEntityId]
    return (serverCache && serverCache[report]) || []
  }
}

const actions = {
  async fetch ({ commit }) {
    commit(FETCH_SERVERS)
    try {
      const response = await axios.get(`${API_URL}/monitor`)
      commit(FETCH_SERVERS_SUCCESS, response.data.data)
    } catch (error) {
      commit(FETCH_SERVERS_FAILURE)
    }
  },

  select ({ commit }, id) {
    commit(SELECT_SERVER_ID, id)
  },

  async fetchImages ({ commit, state }, { server, report }) {
    const names = state.entities[server][report]

    if (!names) {
      return
    }

    const images = await Promise.all(names.map(async image => {
      const response = await axios({
        method: 'get',
        url: `${API_URL}/monitor/item?server=${server}&file=${image}`,
        responseType: 'arraybuffer'
      })
      const encoded = Buffer.from(response.data, 'binary').toString('base64')
      return [image, encoded]
    }))

    commit(CACHE_REPORT_IMAGES, { server, report, images })
  }
}

const mutations = {
  [FETCH_SERVERS] (state) {
    Object.assign(state, {...initialState})
    state.isFetching = true
  },
  [FETCH_SERVERS_SUCCESS] (state, entities) {
    state.isFetching = false
    state.entities = entities
    state.ids = Object.keys(entities).sort()
    state.selectedEntityId = state.ids[0]
  },
  [FETCH_SERVERS_FAILURE] (state) {
    state.isFetching = false
  },
  [SELECT_SERVER_ID] (state, id) {
    state.selectedEntityId = id
  },
  [CACHE_REPORT_IMAGES] (state, { server, report, images }) {
    if (!state.cache[server]) {
      state.cache = { ...state.cache, [server]: {} }
    }
    if (state.cache[server][report]) {
      state.cache[server][report] = images
    } else {
      state.cache[server] = { ...state.cache[server], [report]: images }
    }
  }
}

export default {
  namespaced: true,
  state: {...initialState},
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/servers.js